var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Layouting = require("../Basic/Layouting");

var _PropsHelper = require("../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Table/Row.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Row = function (_React$Component) {
  (0, _inherits2.default)(Row, _React$Component);

  var _super = _createSuper(Row);

  function Row() {
    var _this;

    (0, _classCallCheck2.default)(this, Row);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.calcBackgroundColor = function (item) {
      var _this$props$backgroun = _this.props.backgroundColor,
          even = _this$props$backgroun.even,
          odd = _this$props$backgroun.odd,
          evenHighlight = _this$props$backgroun.evenHighlight,
          oddHighlight = _this$props$backgroun.oddHighlight;

      if ((0, _PropsHelper.executeFunctionOrUndefined)(_this.props.checkHighlight, item)) {
        if (_this.props.even) {
          return evenHighlight || '';
        }

        return oddHighlight || '';
      }

      if (_this.props.even) {
        return even || '';
      }

      return odd || '';
    };

    return _this;
  }

  (0, _createClass2.default)(Row, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          item = _this$props.item,
          onPress = _this$props.onPress,
          NavWrapper = _this$props.NavWrapper,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["item", "onPress", "NavWrapper"]);
      var onPressRow = (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onPress, item || {});
      return _react.default.createElement(_Layouting.BasicTableRow, (0, _extends2.default)({
        height: 36,
        borderX: 1,
        borderY: 1,
        borderColor: "border.main",
        mb: 2,
        onPress: onPressRow,
        bg: this.calcBackgroundColor(item),
        NavWrapper: NavWrapper
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53,
          columnNumber: 13
        }
      }), this.props.children);
    }
  }]);
  return Row;
}(_react.default.Component);

Row.propTypes = {
  item: _propTypes.default.object,
  onPress: _propTypes.default.func,
  even: _propTypes.default.bool,
  backgroundColor: _propTypes.default.object,
  checkHighlight: _propTypes.default.func,
  NavWrapper: _propTypes.default.func
};
Row.defaultProps = {
  backgroundColor: {
    even: {},
    odd: {},
    evenHighlight: {},
    oddHighlight: {}
  }
};
var _default = Row;
exports.default = _default;